var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Support_Request_Icon",
    "data-name": "Support Request Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2630",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2630",
    d: "M64,43.313A20.735,20.735,0,0,0,48.851,23.377,24.437,24.437,0,1,0,3.389,36.859L.09,48.785l11.926-3.3A24.347,24.347,0,0,0,23.377,48.85,20.694,20.694,0,0,0,53.839,61.124L63.91,63.91,61.124,53.839A20.613,20.613,0,0,0,64,43.313ZM12.608,41.432l-7.14,1.975,1.975-7.14-.45-.7a20.681,20.681,0,1,1,6.319,6.319Zm45.924,17.1-5.3-1.466-.708.46a16.944,16.944,0,0,1-25.271-8.815A24.484,24.484,0,0,0,48.712,27.254a16.944,16.944,0,0,1,8.814,25.272l-.46.708Zm0,0",
    fill: "#100b28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2631",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2631",
    d: "M180.5,271h3.765v3.765H180.5Zm0,0",
    transform: "translate(-157.943 -237.133)",
    fill: "#009cbd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2632",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2632",
    d: "M146.794,97.529a3.726,3.726,0,0,1-1.225,2.779l-4.421,4.047v4.594h3.765v-2.936l3.2-2.927a7.529,7.529,0,1,0-12.61-5.556h3.765a3.765,3.765,0,0,1,7.529,0Zm0,0",
    transform: "translate(-118.583 -78.768)",
    fill: "#009cbd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportReceived);
export default __webpack_public_path__ + "static/media/support-received.3797f03f3feec39058f17dd5528e074f.svg";
export { ForwardRef as ReactComponent };